import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';

import { BackButton } from '../../shared/buttons/back-button';
import { OnboradingService, OnboardingSubmitPayload } from '../shared/service/onboarding.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-review',
  standalone: true,
  imports: [CommonModule, FormsModule, BackButton, TranslatePipe],
  templateUrl: './review.html',
})
export class Review implements OnInit, OnDestroy {
  crprtOnbrdngSeq: number | null = null;
  clntSeq: number | null = null;

  isViewMode = false;
  isSubmitting = false;

  comment: string = '';
  comments: any[] = [];

  currentUser: any = null;
  userInitials: string = '';

  private subs: Subscription[] = [];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private onboarding: OnboradingService,
    private translate: TranslateService,
  ) {}

  ngOnInit(): void {
    // ================= ROUTE PARAMS =================
    this.subs.push(
      this.route.paramMap.subscribe((params) => {
        const id = params.get('id');

        if (id) {
          this.crprtOnbrdngSeq = +id;
          this.onboarding.setCorporateSeq(+id);
          this.loadReview(+id);
        }
      }),
    );

    // ================= QUERY PARAMS =================
    this.subs.push(
      this.route.queryParamMap.subscribe((params) => {
        const clientSeq = params.get('clientSeq');

        if (clientSeq) {
          this.clntSeq = +clientSeq;
          this.onboarding.setClientSeq(+clientSeq);
        }

        this.isViewMode = params.get('mode') === 'view';
      }),
    );
  }

  // ================= GET REVIEW =================
  loadReview(onbrdngSeq: number): void {
    this.onboarding.getOnboardingReview(onbrdngSeq).subscribe({
      next: (res) => {
        this.comments = Array.isArray(res) ? res : [];

        if (this.comments.length > 0) {
          const latest = this.comments[this.comments.length - 1];

          this.currentUser = {
            fullName: latest?.crtdBy || '-',
            role: latest?.rvwrRl || '-',
            createdDate: latest?.crtdDt || null,
          };

          this.userInitials = this.getInitials(this.currentUser.fullName);
        }
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  /**
   * Comment ab seedha SubmitOnboarding ke payload (entySeq, entyType, cmmnt)
   * mein jata hai — saveOnboardingReview ki alag call ki zaroorat nahi.
   */
  forward(): void {
    if (this.isViewMode) return;

    if (this.isSubmitting) return;

    if (!this.comment.trim()) {
      this.toastr.warning(this.translate.instant('ONB_REVIEW.ADD_COMMENT_BEFORE_FORWARDING'));
      return;
    }

    if (!this.crprtOnbrdngSeq) {
      this.toastr.error(this.translate.instant('ONB_CLIENT_LIST.ONBOARDING_SEQ_MISSING'));
      return;
    }

    const payload: OnboardingSubmitPayload = {
      entySeq: this.crprtOnbrdngSeq,
      entyType: 3,
      cmmnt: this.comment.trim(),
    };

    this.isSubmitting = true;

    this.onboarding.SubmitOnboarding(payload).subscribe({
      next: (submitRes: any) => {
        // 200 response ke andar agar error ho to route par na jao
        // (toast already shown by ErrorInterceptor for this case)
        if (
          submitRes?.error ||
          submitRes?.success === false ||
          submitRes?.status === false
        ) {
          this.isSubmitting = false;
          return;
        }

        this.comment = '';

        this.toastr.success(
          submitRes?.message ||
            this.translate.instant('ONB_REVIEW.SUBMITTED_SUCCESS')
        );

        this.isSubmitting = false;

        this.router.navigate(['/onboard']);
      },
      error: (err: any) => {
        const rawMsg =
          err?.error?.error ||
          err?.error?.message ||
          err?.message ||
          this.translate.instant('ONB_REVIEW.FAILED_TO_SUBMIT');

        const msg = /please fill the risk fac?ta questionnaire/i.test(rawMsg)
          ? this.translate.instant('ONB_REVIEW.COMPLETE_KYC_BEFORE_SUBMIT')
          : rawMsg.replace(/Risk\/FATCA/gi, 'KYC');

        this.toastr.error(msg);
        this.isSubmitting = false;
      },
    });
  }

  // ================= INITIALS =================
  getInitials(name: string): string {
    if (!name) return 'U';

    const parts = name.trim().split(' ');

    if (parts.length === 1) {
      return parts[0].substring(0, 2).toUpperCase();
    }

    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }

  ngOnDestroy(): void {
    this.subs.forEach((s) => s.unsubscribe());
  }
}